import fetch from 'src/http/fetch'

// 根据openId获取memberId
export function getByOpenId (openId) {
  return fetch('member/getByOpenId', {
    openId: openId
  })
}



// WEBPACK FOOTER //
// ./src/api/memberApi.js